import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { IPropertyFilterRequest } from './request/property-filter-request.interface';
import { IProperty, IRecommendedProperty } from '../models/property/property.interface';
import { IRecommendationRequest } from './request/recommendation-request.interface';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PropertyRecommendationService {

  constructor(private http: HttpClient) {
  }

  private getHostUrl = () => {
    return environment.scheme + environment.host + environment.port + '/';
  };

  public readonly getSubsetUrl = `${this.getHostUrl()}api/v${environment.version}/PropertyRecommendation/subset`;
  public readonly getRecommendationUrl = `${this.getHostUrl()}api/v${environment.version}/PropertyRecommendation/recommendation`;
  public readonly getExportExcelUrl = `${this.getHostUrl()}api/v${environment.version}/PropertyRecommendation/exportExcel`;
  private readonly getSpecialOffersUrl = `${this.getHostUrl()}api/v${
    environment.version}/PropertyRecommendation/getSpecialOfferOptions`;

  createSubset(propertyFilter: IPropertyFilterRequest): Observable<IProperty[]> {
    return this.http.post<any>(this.getSubsetUrl, propertyFilter);
  }

  createRecommendation(recommendationRequest: IRecommendationRequest): Observable<IRecommendedProperty[]> {
    return this.http.post<any>(this.getRecommendationUrl, recommendationRequest);
  }

  exportExcel(recommendedProperties: IRecommendedProperty[]): Observable<HttpResponse<Blob>> {
    return this.http.post(
      this.getExportExcelUrl,
      recommendedProperties,
      {
        observe: 'response',
        responseType: 'blob'
      }
    ) as Observable<HttpResponse<Blob>>;
  }

  getSpecialOffersOptions(): Observable<any> {
    return this.http.get<any>(this.getSpecialOffersUrl);
  }
}
